/**
 * Since1999Stamp — A1 Screening "Since 1999" trust block.
 *
 * Live on the Home Owner section. Reads as a small premium trust panel:
 *  - Large serif "1999" numeral with a cyan-to-yellow accent
 *  - "26+ Florida Storm Seasons" (verified, not 24/7-style)
 *  - "Family-Owned · Naples-Based" (verified)
 *  - 5-stripe inline-SVG that visualizes the spans of A1's coverage
 *
 * No new claims, no schema. All text is already on the existing site.
 *
 * Layout:
 *  - Horizontal full-width strip on every breakpoint (lives inside the
 *    Owner section's right column, below the CTA). Stacks gracefully on
 *    mobile.
 */
export default function Since1999Stamp() {
    return (
        <aside
            className="a1-since1999"
            role="complementary"
            aria-label="Family-owned since 1999"
            data-testid="since-1999-stamp"
        >
            <div className="a1-since1999-numeral" aria-hidden="true">
                <span className="a1-since1999-1">1</span>
                <span className="a1-since1999-9-9-9">999</span>
            </div>
            <div className="a1-since1999-divider" aria-hidden="true">
                <YearStripes />
            </div>
            <div className="a1-since1999-meta">
                <p className="a1-since1999-eyebrow">Family-Owned</p>
                <p className="a1-since1999-headline">26+ Florida Storm Seasons</p>
                <p className="a1-since1999-sub">Naples-Based · Serving Southwest Florida since 1999.</p>
            </div>
        </aside>
    );
}

/** 5 stacked stripes that visualize the years A1 has been serving SWFL. */
function YearStripes() {
    return (
        <svg
            viewBox="0 0 80 56"
            width="80"
            height="56"
            fill="none"
            aria-hidden="true"
        >
            {/* 5 stripes representing 5 spans of years. Each gets longer toward
                the present, suggesting accumulating experience without making
                a specific dated claim per stripe. */}
            <rect x="0"  y="6"  width="38" height="5" rx="2.5" fill="rgba(40, 216, 224, 0.35)" />
            <rect x="0"  y="16" width="48" height="5" rx="2.5" fill="rgba(40, 216, 224, 0.55)" />
            <rect x="0"  y="26" width="58" height="5" rx="2.5" fill="rgba(40, 216, 224, 0.72)" />
            <rect x="0"  y="36" width="68" height="5" rx="2.5" fill="rgba(40, 216, 224, 0.90)" />
            <rect x="0"  y="46" width="78" height="5" rx="2.5" fill="var(--color-cta)" />
        </svg>
    );
}
